import React from 'react';

export function GridBackground() {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      <div className="absolute inset-0 grid-background opacity-20" />
      <div className="absolute inset-0">
        <div className="grid-line grid-line-h" />
        <div className="grid-line grid-line-v" />
      </div>
      <div className="absolute inset-0 radial-mask bg-gradient-to-b from-blue-500/20 via-slate-950/50 to-slate-950" />
    </div>
  );
}